'use client';

import { c as _c } from "react/compiler-runtime";
import type { DateDrawsResultDate } from '@svs/nova-poolbetting/schema/date-picker';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import { Tabs, TabsList, TabsTrigger } from '@svs/ui/react/tabs';
import { type ReactNode } from 'react';
type CouponResultDrawMenuProps = {
  dateDraws: DateDrawsResultDate[];
  drawNumber: DrawNumber;
  onChange: (value: string) => void;
};

/**
 * Component for rendering a menu to select different draw numbers for a given date.
 *
 * @param param0 - The props object.
 * @param param0.dateDraws - The draws for the selected date, used to populate the menu with available draw numbers.
 * @param param0.drawNumber - The currently selected draw number, used to disable the corresponding button in the menu.
 * @param param0.onChange - Callback function to handle changes in the selected draw number, typically by updating the URL query parameters.
 * @returns A ReactNode representing the draw menu, or null if there is only one draw number.
 */
export function CouponResultDrawMenu(t0) {
  const $ = _c(7);
  const {
    dateDraws,
    drawNumber,
    onChange
  } = t0;
  let t1;
  if ($[0] !== dateDraws || $[1] !== drawNumber) {
    t1 = (dateDraws.find(dateDraw => dateDraw.drawNumber === drawNumber) ?? dateDraws[0])?.drawNumber.toString();
    $[0] = dateDraws;
    $[1] = drawNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedDrawNumber = t1;
  let t2;
  if ($[3] !== dateDraws || $[4] !== onChange || $[5] !== selectedDrawNumber) {
    t2 = dateDraws.length > 1 && <Tabs defaultValue={selectedDrawNumber} onValueChange={onChange} className="mb-4"><TabsList className="w-full rounded-md">{dateDraws.map(_temp)}</TabsList></Tabs>;
    $[3] = dateDraws;
    $[4] = onChange;
    $[5] = selectedDrawNumber;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(dateDraw_0, index) {
  return <TabsTrigger key={dateDraw_0.drawNumber} className="w-full" value={dateDraw_0.drawNumber.toString()} aria-label={`Visa omgång ${index + 1}`}>Omgång {index + 1}</TabsTrigger>;
}